import { useEffect, useState } from 'react';

import ProductVariant from '@/shared/types/products/productVariant.type';

type Args = {
  reset?: boolean;
};

const useSelectedProductsList = ({ reset }: Args) => {
  const [selectedProducts, setSelectedProducts] = useState<ProductVariant[]>(
    [],
  );

  const onUpdateSelectedProduct = (product: ProductVariant) => {
    setSelectedProducts((prev) =>
      prev.map((item) =>
        item.variant_id === product.variant_id ? { ...item, ...product } : item,
      ),
    );
  };

  const onAddProductToSelection = (product: ProductVariant) => {
    const itemInTheCart = selectedProducts.find(
      (item) => item.variant_id === product.variant_id,
    );

    itemInTheCart
      ? onUpdateSelectedProduct({
          ...product,
          product_qty: parseInt(product.product_qty as string) + 1,
        })
      : setSelectedProducts((prev) => [...prev, product]);
  };

  const onDeleteSelectedProduct = (id: string) => {
    setSelectedProducts((prev) =>
      prev.filter((item) => item.variant_id !== id),
    );
  };

  useEffect(() => {
    if (reset) {
      setSelectedProducts([]);
    }
  }, [reset]);

  return {
    selectedProducts,
    onAddProductToSelection,
    onUpdateSelectedProduct,
    onDeleteSelectedProduct,
  };
};

export default useSelectedProductsList;
